<template>
  <vl-modal v-if="session" :open="isShow" maxWidth="830" :footerOffsetTop="0" :canCancel="false">
    <template #header>
      <countdown :left-time="30000" @finish="redirectAfterFinished">
        <template v-slot:process="timer">
          <span>
            {{
              `${t[locale]['session_popup.title']} ${timer.timeObj.ceil.s} ${t[locale]['session_popup.title_next']}`
            }}
          </span>
        </template>
        <template v-slot:finish>
          {{ t[locale]['session_popup.title_finished'] }}
        </template>
      </countdown>
    </template>
    <vl-button size="large" type="primary" @click.native="hideModal">
      {{ t[locale]['session_popup.btn'] }}
    </vl-button>
  </vl-modal>
</template>
<script>
import VlModal from '@components/@oschad/ui/vl-modal'
import VlButton from '@components/@oschad/ui/vl-button'
import showSessionPopup from '@javascript/mixins/showSessionPopup'

import { redirectTo } from '@javascript/utils/helper-methods'
import { AUTHORIZATION_LOGIN } from '@javascript/config/routes'
import locales from './locales'

export default {
  name: 'SessionPopup',
  mixins: [showSessionPopup],
  inject: ['locale', 'defaultLocale'],
  components: {
    VlModal,
    VlButton,
  },
  props: {
    session: {
      type: Number | String,
      default: null,
    },
  },
  data: () => ({
    t: locales,
  }),
  methods: {
    redirectAfterFinished() {
      redirectTo(AUTHORIZATION_LOGIN)
    },
    // someProcess(e) {
    //   e.actualEndTime = this.timeToEnd()
    // },
  },
}
</script>
